import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Gantt from 'common/gantt/containers/gantt-container';

const StyledWrapper = styled.div`
  margin-top: 0px;
  ${p => p.visible || css`
    visibility: hidden;
  `}
`;

const PlanningBoardGantt = ({ split, selectedOrderIds, fullScreen, visible, parent }) =>
  <StyledWrapper visible={visible}>
    <Gantt split={split} selectedIds={selectedOrderIds} fullScreen={fullScreen} parent={parent} />
  </StyledWrapper>;

PlanningBoardGantt.propTypes = {
  selectedOrderIds: PropTypes.array.isRequired,
  split: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool,
  visible: PropTypes.bool,
  parent: PropTypes.object,
};

export default PlanningBoardGantt;
